import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api-client';

export interface AuthMe {
  id: number;
  email: string;
  fullName: string;
  isAdmin: boolean;
}

export const AUTH_ME_KEY = ['auth-me'] as const;

export function useAuthMe(opts: { enabled?: boolean } = {}) {
  return useQuery<AuthMe, Error>({
    queryKey: AUTH_ME_KEY,
    queryFn: () => apiFetch<AuthMe>('/auth/me'),
    enabled: opts.enabled ?? true,
    staleTime: 5 * 60 * 1000,
  });
}
